// This file is deprecated. Logic moved to src/filters/index.ts
// Re-exporting filters as a plugin for Vue 3 compatibility during migration.
import { filters } from './filters/index'

export default {
  install (app) {
    app.config.globalProperties.$filters = filters
  }
}
